import { z } from 'zod';

export const SimulationSettingEnum = {
  // SMS Connection
  SMS_CONNECTION: 'sms_connection',
  // Contact Center
  CONTACT_CENTER: 'contact_center',
  // Code Verification
  CODE_VERIFICATION: 'code_verification',
  // Contact Creation
  CONTACT_CREATION: 'contact_creation',
  // Manual Verification
  MANUAL_VERIFICATION: 'manual_verification',
  // Application Submission
  APPLICATION_SUBMISSION: 'application_submission',
  // Call Connection
  CALL_CONNECTION: 'call_connection',
  // Experian Verification
  EXPERIAN_VERIFICATION: 'experian_verification'
} as const;

export type SimulationSetting = typeof SimulationSettingEnum[keyof typeof SimulationSettingEnum];

export const simulationSettingsSchema = z.object({
  // SMS Connection Response
  [SimulationSettingEnum.SMS_CONNECTION]: z.enum([
    'success',
    'user_exists',
    'invalid_phone',
    'service_unavailable'
  ]),
  
  // Contact Center Availability
  [SimulationSettingEnum.CONTACT_CENTER]: z.enum([
    'available',
    'unavailable',
    'partial'
  ]),
  
  // Code Verification Response
  [SimulationSettingEnum.CODE_VERIFICATION]: z.enum([
    'success',
    'invalid_code',
    'expired_code',
    'too_many_attempts'
  ]),
  
  // Contact Creation Response
  [SimulationSettingEnum.CONTACT_CREATION]: z.enum([
    'qualified',
    'qualified_tier2',
    'rejected',
    'error',
    'error_500'
  ]),
  
  // Manual Verification Response
  [SimulationSettingEnum.MANUAL_VERIFICATION]: z.enum([
    'qualified',
    'unqualified',
    'not_found',
    'invalid_data'
  ]),
  
  // Application Submission Response
  [SimulationSettingEnum.APPLICATION_SUBMISSION]: z.enum([
    'success',
    'rejected',
    'system_error'
  ]),

  // Call Connection Response
  [SimulationSettingEnum.CALL_CONNECTION]: z.enum([
    'success',
    'invalid_record',
    'server_error'
  ]),

  // Experian Verification Response
  [SimulationSettingEnum.EXPERIAN_VERIFICATION]: z.enum([
    'qualified',
    'qualified_tier2',
    'rejected',
    'error',
    'error_500'
  ])
});

export type SimulationSettings = z.infer<typeof simulationSettingsSchema>;

export const defaultSimulationSettings: SimulationSettings = {
  [SimulationSettingEnum.SMS_CONNECTION]: 'success',
  [SimulationSettingEnum.CONTACT_CENTER]: 'available',
  [SimulationSettingEnum.CODE_VERIFICATION]: 'success',
  [SimulationSettingEnum.CONTACT_CREATION]: 'qualified',
  [SimulationSettingEnum.MANUAL_VERIFICATION]: 'qualified',
  [SimulationSettingEnum.APPLICATION_SUBMISSION]: 'success',
  [SimulationSettingEnum.CALL_CONNECTION]: 'success',
  [SimulationSettingEnum.EXPERIAN_VERIFICATION]: 'qualified'
};